module.exports = __webpack_public_path__ + "img/icon_diamond.9760d72.webp";